<!-- SuccessScreen.vue -->
<template>
  <div class="success-screen content">
    <div class="success-icon">
      <i class="fas fa-check fa-3x"></i>
    </div>
      <h2 v-underline-primary>{{ $t('report.success.title') }}</h2>
      <p>{{ $t('report.success.thanks') }}</p>
      <section v-if="points && points.awarded > 0" class="points-card" aria-labelledby="pts-h">
        <h3 id="pts-h">{{ $t('report.success.pointsTitle', { n: points.awarded }) }}</h3>
        <ul>
          <li v-for="row in points.breakdown" :key="row.key"><span>{{ $t('report.success.pointsRows.' + row.key) }}</span><strong>+{{ row.points }}</strong></li>
        </ul>
        <p class="total">{{ $t('report.success.pointsTotal', { n: Math.round(points.total) }) }}</p>
        <p v-if="tips.length" class="tips">{{ $t('report.success.pointsTips', { tips: tips.join(', ') }) }}</p>
      </section>
      <p v-else-if="points && points.limited" class="muted">{{ $t('report.success.pointsLimited') }}</p>
      <router-link :to="$lp('/explore')">
        <button class="btn-cta"><i class="fas fa-map"></i> {{ $t('report.success.explore') }} </button>
      </router-link>
        <AdviceSection
            ref="recsSection"
            v-if="contentRecs"
            :h2="$t('report.success.contentTitle')"
            :subtitle="$t('report.success.contentSubtitle')"
            :result="contentRecs"
            :ratings="ratings"
            @update-rating="updateRating" 
            @select-sticky-note="selectedStickyNote = $event"
        />
    </div>
  </template>
  
  <script>
  import AdviceSection from "./AdviceSection.vue";
  
  export default {
    name: "SuccessScreen",
    components: {
      AdviceSection,
    },
    props: {
      infrastructureAdvice: {
        type: Array,
        required: true
      },
      contentRecs: {
        type: Array,
        required: true
      },
      points: { type: Object, default: null },
    },
    computed: {
      // what the report did not have yet, so the next one can earn more
      tips() {
        const got = new Set(((this.points && this.points.breakdown) || []).map((r) => r.key));
        return ['rating', 'labels', 'comment', 'ideas', 'public'].filter((k) => !got.has(k)).map((k) => this.$t('report.success.pointsTip.' + k));
      },
    },

  };
  </script>
  
  <style>
.points-card { background: var(--color-subtle); border-radius: var(--radius-lg); padding: 16px; margin: 16px 0; text-align: start; }
.points-card h3 { margin: 0 0 8px; }
.points-card ul { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 4px; }
.points-card li { display: flex; justify-content: space-between; gap: 12px; }
.points-card .total, .points-card .tips { margin: 8px 0 0; font-size: 14px; color: var(--color-secondary); }

.success-screen {
  display: flex;
  flex-direction: column;
  animation: fade-in 1s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
  .recommendations {
    margin-top: 30px;
  }

  .success-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.success-icon i {
  color: var(--color-on-primary);
  background-color: var(--color-primary);
  border-radius: 50%;
  padding: 1rem;
  animation: spin 1s linear 1;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

  </style>
  